var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeGeneration({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.265 14.625H5.625C5.16 14.625 4.7475 14.61 4.38 14.5575C2.4075 14.34 1.875 13.41 1.875 10.875V7.125C1.875 4.59 2.4075 3.66 4.38 3.4425C4.7475 3.39 5.16 3.375 5.625 3.375H8.22",
    stroke: "#0A49A5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2646 3.375H12.3746C12.8396 3.375 13.2521 3.39 13.6196 3.4425C15.5921 3.66 16.1246 4.59 16.1246 7.125V10.875C16.1246 13.41 15.5921 14.34 13.6196 14.5575C13.2521 14.61 12.8396 14.625 12.3746 14.625H11.2646",
    stroke: "#0A49A5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 1.5V16.5",
    stroke: "#0A49A5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32108 9H8.32781",
    stroke: "#0A49A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32108 9H5.32781",
    stroke: "#0A49A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeGeneration);
export default __webpack_public_path__ + "static/media/code-generation.21003ab20ad32c3a79b2dbf068fa48c2.svg";
export { ForwardRef as ReactComponent };